module.exports = __webpack_public_path__ + "static/media/blog-background.f5f44c21.webp";